<template>
    <aside class="prod-sidebar">
        <div class="ps-title">Filtrar por</div>

        <div class="filter-group" v-for="group in groups" :key="group.key">
            <span class="fg-label">{{ group.label }}</span>
            <div class="fg-options">
                <button type="button" :class="{ active: localFilters[group.key] === null }"
                    @click="select(group.key, null)">
                    {{ group.allLabel }}
                </button>
                <button type="button" v-for="option in group.options" :key="option.value"
                    :class="{ active: localFilters[group.key] === option.value }"
                    @click="select(group.key, option.value)">
                    {{ option.label }}
                </button>
            </div>
        </div>

        <button type="button" class="prod-reset" @click="reset">↺ Limpiar filtros</button>
    </aside>
</template>

<script>
export default {
    inject: ['axios', 'locale'],

    props: {
        modelValue: Object
    },

    emits: ['update:modelValue', 'reset'],

    data: () => ({
        supportData: { styles: [], colors: [], materials: [] },
        localFilters: {
            style: null,
            color: null,
            material: null,
        }
    }),

    computed: {
        filters: {
            get() { return this.modelValue },
            set(value) { this.$emit('update:modelValue', value) }
        },

        groups() {
            return [
                { key: 'style', label: 'Estilo', allLabel: 'Todos', options: this.supportData.styles || [] },
                { key: 'color', label: 'Color', allLabel: 'Todos', options: this.supportData.colors || [] },
                { key: 'material', label: 'Material', allLabel: 'Todos', options: this.supportData.materials || [] },
            ]
        }
    },

    methods: {
        select(key, value) {
            this.localFilters[key] = value
            this.setFilters()
        },

        setFilters() {
            this.filters['filters[style]'] = this.localFilters.style
            this.filters['filters[color]'] = this.localFilters.color
            this.filters['filters[material]'] = this.localFilters.material
            this.filters.page = 1
        },

        reset() {
            this.localFilters = { style: null, color: null, material: null }
            this.$emit('reset')
        }
    },

    async mounted() {
        const { data } = await this.axios.get('/products/support-data')
        this.supportData = data.data
    }
}
</script>
